import { APP_BASE_HREF, KeyValue } from '@angular/common';
import { Component, Inject, Input, OnInit, ChangeDetectorRef, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppService } from '@app/_core/services/app.service';
import { TranscriptService } from '@app/_core/services/transcript-service.service'
import { ResponseHandler } from '../../../_core/helper/ResponseHandler';
import { catchError, EMPTY, interval, map, Subscription, of, from } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-call-transcript',
    templateUrl: './call-transcript.component.html',
    styleUrl: './call-transcript.component.scss'
})
export class CallTranscriptComponent implements OnInit, OnDestroy {
    @ViewChild('list') list?: ElementRef<HTMLDivElement>;
    @Input()
    Heading: any;
    isAgent: boolean;
    InteractionId: any;
    CallID: any;
    RecordingID: any;
    showFirstSec: boolean;
    searchTerms: any = '';//
    transcriptDataReset: any = {
        "CallId": null,
        "RecordingId": null,
        "TranscriptId": null,
        "CallSummary": null,
        "IssueIdentified": null,
        "ActionTaken": null,
        "CaseNotes": null,
        "IssueResolved": null,
        "CustomerSatisfaction": null,
        "Sentiment": null,
        "ID": null,
        "Sentences": []
    };
    transcriptData: any = this.transcriptDataReset;
    searchval: string = '';
    Sentiment: string = 'NA';
    filteredKeywordArray: any = [{
        'Name': '--Select--',
        'Value': '-1',
        'selected': true
    }];
    TranscriptHistoryArray: any = [{
        'Name': '--Select--',
        'Value': '-1',
    }];
    WordMatches: any = [];
    selectedKey: string = '-1';
    TranscriptID: string = '-1';
    isTranscriptHistory: boolean = false;
    isKeyword: boolean = false;
    isLivefeed: boolean = false;
    private mySubscription: Subscription;
    lblMessage: string = '';
    allsearchval: any = [];
    SummaryHeader: { [key: string]: string } =
        {
            'CallSummary': 'Conversation Summary:',
            'CaseNotes': 'Case Notes:',
            'IssueResolved': 'Issue Resolved:',
            'AgentBehavior': 'Agent Behavior:',
            'InCompleteCall': 'InComplete Call:',
            'CustomerSatisfaction': 'Customer Satisfaction:',
            'CallerPurpose': 'Caller Purpose:',
            'IssueIdentified': 'Issue Identified:',
            'ActionTaken': 'Action Taken:',
        };
    Postcalltranscription: boolean = false;
    PostTranscriptData: Subscription;
    PostCallExecutionCount = 0;
    isPostfeed: boolean = false;
    IsMessages:boolean=false;
    constructor(
        @Inject(APP_BASE_HREF) public baseHref: string,
        private router: Router,
        public bsModalRef: BsModalRef,
        private transcriptService: TranscriptService,
        private cdf: ChangeDetectorRef,
        private appService: AppService,
    ) { }
    ngOnDestroy(): void {
        if (this.mySubscription) {
            this.mySubscription.unsubscribe();
        }
        if (this.isLivefeed) {
            //this.transcriptService.SetEmpty();
            this.isLivefeed = false;
            //this.appService.EnableTranscriptTab(true);
            //this.transcriptData = this.transcriptDataReset;
        }
        this.isPostfeed = false;
    }
    ngOnInit(): void {
        this.getpostCallEnable();
        this.showFirstSec = false;
        const url = this.router.url;      
        if (this.isInteractionOrPerformance(url)) {
            this.showFirstSec = true;
            this.getInteractionDetailView();
        } 
        else if (this.InteractionId != null) {
            // this.transcriptData = this.transcriptData.Response.Data;
            this.GetCallAnalytics();
        } else if (this.isPostfeed) {
            this.getInteractionDetailView();
        }
        else {
            this.transcriptData = this.transcriptDataReset;
            this.getCallTranscript();
        }
    } 
    closeCaseCreation() {
        this.bsModalRef.hide();
    }


    getCallTranscript() {
        if (this.transcriptService.LiveTranscriptSummary != null) {
            this.mySubscription = this.transcriptService.LiveTranscriptSummary.subscribe((value: any) => {
                if (value != null) {
                    this.isLivefeed = true;
                    this.IsMessages=true;
                    this.transcriptData = value;
                    this.TranscriptScroll();
                    this.transcriptService.setTranscriptSnapshot(this.transcriptData);
                }
            });
        }
    }
    GetCallAnalytics() {
        this.transcriptService.
            GetCallAnalytics(this.InteractionId, this.CallID, this.RecordingID)
            .pipe(
                map((data: any) => {
                    const isValid = ResponseHandler.processResponse(data, 'GetCallAnalytics');
                    if (isValid) {
                        this.transcriptData = data.Response.Data;
                        this.lblMessage = '';
                        if (this.transcriptData == null) this.lblMessage = data.Response.Message;
                    }
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    GetParentByInteractionID() {
        this.transcriptService.
            GetParentByInteractionID(this.InteractionId)
            .pipe(
                map((data: any) => {
                    const isValid = ResponseHandler.processResponse(data, 'GetParentByInteractionID');
                    if (isValid) {
                        this.isTranscriptHistory = false;
                        let TransData = data.Response.Data;
                        if (TransData.length > 1) {
                            this.isTranscriptHistory = true;
                            this.TranscriptHistoryArray = this.TranscriptHistoryArray.filter(item => item.Value === '-1');
                            for (var i in TransData) {
                                this.TranscriptHistoryArray.push({ Name: TransData[i].Description, Value: TransData[i].InteractionID });
                            }
                            //   console.log(this.TranscriptHistoryArray);
                        }
                        this.TranscriptID = this.InteractionId;
                        this.onChangeTranscriptHistory(this.TranscriptID);
                    }
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    GetPostCallAnalyticsByInteractionID() {
        this.transcriptService.
            GetPostCallAnalyticsByInteractionID(this.InteractionId)
            .pipe(
                map((data: any) => {
                    const isValid = ResponseHandler.processResponse(data, 'GetPostCallAnalyticsByInteractionID');
                    if (isValid) {
                        //if (this.PostTranscriptData) this.PostTranscriptData.unsubscribe();
                        this.lblMessage = '';
                        this.transcriptData = data.Response.Data;
                        if (this.transcriptData == null) this.lblMessage = data.Response.Message;
                        if (this.showFirstSec) {
                            this.SummaryView();
                        }
                    }
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    TranscriptScroll(): void {
        const maxScroll = this.list?.nativeElement.scrollHeight;
        this.list?.nativeElement.scrollTo({ top: maxScroll, behavior: 'smooth' });
    }
    ngAfterViewInit() {
        this.TranscriptScroll();
    }

    searchAndHighlight() {
        if (this.searchval != '' && this.searchval != null) {
            this.searchTerms = this.searchval;
            this.allsearchval.push(this.searchval);
            this.allsearchval = [...new Set(this.allsearchval)];
            this.searchTerms = this.allsearchval.join('|');

            this.cdf.detectChanges();
        }
    }


    ClearSearch() {
        this.searchval = '';
        this.searchTerms = '';
        this.selectedKey = '-1';
        if (this.allsearchval.length > 0) {
            this.allsearchval = [];
        }
        this.cdf.detectChanges();
    }
    SummaryView() {
        this.ClearSearch();
        this.filteredKeywordArray = this.filteredKeywordArray.filter(item => item.Value === '-1');
        this.isKeyword = false;
        this.Sentiment = this.toPascalCase(this.transcriptData.Sentiment);
        if (this.transcriptData.PhraseMatches.length > 0) {
            let PhraseMatches = this.transcriptData.PhraseMatches.filter(item => item?.Category !== null && item?.Category !== undefined);
            for (var i in PhraseMatches) {
                this.filteredKeywordArray.push({
                    'Name': PhraseMatches[i].Category,
                    'Value': PhraseMatches[i].Category
                });
            }
            this.WordMatches = PhraseMatches;
            this.isKeyword = true;
        }
    }
    onChange(item: string) {
        this.ClearSearch();
        this.selectedKey = item;
        if (item != '-1') {
            var uniq = this.WordMatches.filter(x => x.Category === item).map(function (a) {
                return a.Matches;
            })[0];
            let SearchWordMatches = [...new Set(uniq)];
            this.allsearchval.push(SearchWordMatches);
            this.searchTerms = SearchWordMatches.join('|');
            this.cdf.detectChanges();
        }
    }
    onChangeTranscriptHistory(ID: string) {
        this.InteractionId = ID;
        this.GetPostCallAnalyticsByInteractionID();
    }

    toPascalCase = str => {
        let tempArray = str.split(' ');
        tempArray = tempArray.map(value => value.charAt(0).toUpperCase() + value.slice(1, value.length));
        return tempArray.join(' ');
    };

    getInteractionDetailView() {
        this.mySubscription = this.appService.TranscriptDetails.subscribe(data => {
            this.Postcalltranscription = data.isPostcalltranscription;
            this.InteractionId = data.interactionId;
            //post call transcription fetching the records...
            if (data.interactionId > 0 && data.isPostcalltranscription) {
                this.GetPostCallAnalyticsByInteractionID();
                this.IterationForRecords();
            }
            else if (data.interactionId > 0) {
                this.GetParentByInteractionID();
            }
        });
    }
    IterationForRecords() {
        if (this.PostCallExecutionCount < 2) {
            from([1])
                .pipe(delay(10000))
                .subscribe(action => {
                    this.PostCallExecutionCount++;
                    // console.log('10 seconds later, observable action:', action);
                    // Perform your desired action here 
                    this.GetPostCallAnalyticsByInteractionID();
                    this.IterationForRecords();
                });
        }
    }
    getpostCallEnable() {
        if (this.transcriptService.PostCallTranscript != null) {
            this.mySubscription = this.transcriptService.PostCallTranscript.subscribe((value: any) => {
                if (value != null && this.isPostfeed != value) {
                    this.isPostfeed = value;
                    console.log('Post Call Enabled', value);
                }
            });
        }
    }
    ngAfterViewChecked(): void {
        if(this.IsMessages && this.isLivefeed){
        this.TranscriptScroll();
        this.IsMessages=false;
        }
      } 
      private isInteractionOrPerformance(url: string): boolean {
        const keywords = ['Interactions', 'Performance', 'Audits', 'LiveStatuses','HistoricalMetrics'];
        return keywords.some(keyword => url.includes(keyword));
      } 
}
